import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/checkout.vue").then(m => m.default || m)),
  confirm: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/confirm.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  "footer-links": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/footer-links.vue").then(m => m.default || m)),
  terms: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/terms.vue").then(m => m.default || m))
}